module.exports = __webpack_public_path__ + "static/92525c79-47e7-4dd9-a960-d3a6006cdcb1-ae8923d42b192ad903caf687b6520386.webp";